/* eslint-disable react/display-name */
import React, { forwardRef, JSX } from 'react'
import { DateTimeFieldProps } from './DateTimeField'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { MenuItem, Select, Stack } from '@mui/material'
import moment from 'moment'
import SoloRangeSlider from './SoloRangeSlider'
export interface DateTimeFieldSearchProps {
    kedo: DateTimeFieldProps['kedo']
    date1: string | null
    date2?: string | null
    searchType: string
    withtime: boolean
    show_slider?: boolean
    onChangeSearch: (searchType: string) => void
    onChangeDate: (
        moment: moment.Moment | null,
        name?: string,
        searchType?: string
    ) => void
    getSearchTypeTitle: (searchType: string) => string
    getSearchDateTime: (name: string, value: string | null) => JSX.Element
    isInvalid: () => boolean
    getErrorText: () => string
}

export const DateTimeFieldSearch = forwardRef<
    HTMLDivElement,
    DateTimeFieldSearchProps
>(
    (
        {
            kedo,
            date1,
            date2,
            searchType,
            withtime,
            show_slider,
            onChangeSearch,
            onChangeDate,
            isInvalid,
            getErrorText,
        },
        ref
    ) => {
        const date1Value = date1 ? moment(date1) : null

        const date2Value = date2 ? moment(date2) : null

        return (
            <Stack direction={'row'} spacing={1}>
                <Select
                    value={searchType}
                    onChange={(e) => onChangeSearch(e.target.value)}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value={'on'}> {kedo.t('time_on')}</MenuItem>
                    <MenuItem value={'after'}>{kedo.t('time_after')}</MenuItem>
                    <MenuItem value={'before'}>
                        {' '}
                        {kedo.t('time_before')}
                    </MenuItem>
                    <MenuItem value={'between'}>
                        {' '}
                        {kedo.t('time_from_till')}
                    </MenuItem>
                </Select>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    {!show_slider ? (
                        <DateTimePicker
                            label={kedo.t('select_date_time')}
                            value={date1Value}
                            onChange={(momentValue) => {
                                onChangeDate?.(momentValue, 'date1')
                            }}
                            format={
                                withtime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY'
                            }
                            views={
                                withtime
                                    ? [
                                          'year',
                                          'month',
                                          'day',
                                          'hours',
                                          'minutes',
                                      ]
                                    : ['year', 'month', 'day']
                            }
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                },
                            }}
                        />
                    ) : (
                        <SoloRangeSlider
                            min={18}
                            max={120}
                            type={searchType}
                            onChange={(min, max) => {
                                const tillDate = moment().subtract(min, 'years')
                                const fromDate = moment().subtract(max, 'years')
                                onChangeDate(tillDate, 'date1')
                                onChangeDate(fromDate, 'date2')
                            }}
                        />
                    )}

                    {!show_slider && searchType === 'between' && (
                        <DateTimePicker
                            label={kedo.t('select_date_time')}
                            value={date2Value}
                            onChange={(momentValue) => {
                                onChangeDate?.(momentValue, 'date2')
                            }}
                            format={
                                withtime ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY'
                            }
                            views={
                                withtime
                                    ? [
                                          'year',
                                          'month',
                                          'day',
                                          'hours',
                                          'minutes',
                                      ]
                                    : ['year', 'month', 'day']
                            }
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                },
                            }}
                        />
                    )}
                </LocalizationProvider>

                {isInvalid() ? (
                    <span className="fake-feedback">{getErrorText()}</span>
                ) : null}
            </Stack>
        )
    }
)
